<template>
  <Article v-if="type == 1 || type == 2" :parentId="parentId" :type="type"/>
  <CardInfo v-else-if="type == 3" :parentId="parentId"/>
  <Branch v-else-if="type == 4" :parentId="parentId"/>
</template>

<script>
import Article from "@/components/entry/ArticleCreate.vue";
import CardInfo from "@/components/entry/CardInfoCreate.vue";
import Branch from "@/components/entry/BranchCreate.vue";

export default {
  components: {
    Article,
    CardInfo,
    Branch
  },

  computed: {
    type() {
      return this.$route.params.type;
    },

    parentId() {
      return this.$route.params.parentId;
    }
  },

  methods: {
    goBack() {
      this.$router.push("/submenu/" + this.parentId);
    }
  }
};
</script>
